import API_ROUTES from 'config/apiRoutes';
import http from 'shared/utils/http';
import { BaseAccount, SearchParams } from 'shared/utils/types';

type AccountSearchParams = {
  id?: number;
  minReviewsCount?: number;
  sort?: 'createdAt' | 'averageGrade' | 'reviewsCount' | 'id';
  allowedAccounts?: number[];
  allowedCategories?: number[];
  excludedAccounts?: number[];
  excludedCategories?: number[];
  language?: string;
  onlyWithLogo?: boolean;
  order?: 'DESC' | 'ASC';
  limit?: number;
  offset?: number;
};

export type Account = {
  preferredName: string;
  reviewsCount: number;
  logoName?: string;
  verified: boolean;
  blocked: boolean;
  settings: {
    ratingPrecision: RatingPrecision;
    companyProfilePageHidden: boolean;
    reviewsDisabledFromOrganic: boolean;
    showTranslationsOriginalLanguage: boolean;
    blockedAccountComment: string | null;
    adminComment: string | null;
    id: number;
  };
  subtype: string;
  certificate: boolean;
  certificatedAt: string | null;
  supportedLanguages: string | null;
  createdAt: string;
  reviewsDisabledFromOrganic: boolean;
  cooperating: boolean;
} & BaseAccount;

export interface AccountServiceSearchParams extends AccountSearchParams {
  city?: string;
  minAverageGrade?: number;
  maxAverageGrade?: number;
  categoryTags?: number[];
}

type AccountsRes = {
  totalCount: number;
  items: Account[];
  count: number;
};

type SearchAccountRes = {
  totalCount: number;
  items: BaseAccount[];
  count: number;
};

export async function fetchAccounts(searchParams: AccountSearchParams = {}): Promise<Account[]> {
  const url = http.createApiUrl(API_ROUTES.ACCOUNTS);
  const res = await http.get<AccountsRes>(url, { params: searchParams });
  return res.data.items;
}

export async function searchAccounts(searchParams: SearchParams): Promise<BaseAccount[]> {
  const url = http.createApiUrl(API_ROUTES.ACCOUNTS_SEARCH);
  const res = await http.get<SearchAccountRes>(url, {
    params: searchParams,
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data.items;
}

interface TranslateSlugToUuidParams {
  slug: string;
}

interface SlugToUuidRes {
  uuid: string;
}

// Just for redirection purpuse, can be remove when clients stop using old QR product profiles
export async function translateSlugToUuid({ slug }: TranslateSlugToUuidParams): Promise<string> {
  const url = http.createApiUrl(API_ROUTES.SLUG_TO_UUID).replace(':slug', slug);
  const res = await http.get<SlugToUuidRes>(url);
  return res.data.uuid;
}
